import { ViewPageListTab } from 'app/main/components/page-layouts';
import type { ViewPageContentTabType } from 'app/main/components/page-layouts/view/ViewPage';

import SkillsUsersTab from './tabs/SkillsUsersTab';
import SkillsListItem from '../SkillsListItem';

export default [
	{
		id: 'list',
		title: 'TAB_LIST',
		content: props => <ViewPageListTab {...props} id="skillsView" itemLayout={SkillsListItem} />
	},
	{
		id: 'users',
		title: 'TAB_SKILLS_USERS',
		content: SkillsUsersTab
	}
] as ViewPageContentTabType[];
